module.exports = __webpack_public_path__ + "static/media/etsyIconTrd.5d70259f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/etsyIconTrd.svg
// module id = 135
// module chunks = 0